import { render, staticRenderFns } from "./DetachChannelModal.vue?vue&type=template&id=2ade53f5&scoped=true"
import script from "./DetachChannelModal.vue?vue&type=script&lang=ts"
export * from "./DetachChannelModal.vue?vue&type=script&lang=ts"
import style0 from "./DetachChannelModal.vue?vue&type=style&index=0&id=2ade53f5&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ade53f5",
  null
  
)

export default component.exports